import { motion } from "framer-motion";
import Content from "../components/Content";
import { changeColorState, weatherData } from "../utils/atom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { Suspense, useEffect } from "react";


export function Seoul (){
    const data = useRecoilValue(weatherData)
    const setColorState = useSetRecoilState(changeColorState);

    useEffect(()=>{
        const weather = data[0]?.weatherData?.weather[0].main;
        if(weather == "Clouds"){
            setColorState("radial-gradient(circle, rgb(41, 124, 188) 0%, rgb(8, 40, 101) 100%)");
        }else if(weather == "Clear"){
            setColorState("radial-gradient(circle, rgb(239, 255, 174) 0%, rgb(92, 147, 248) 100%)");
        }else if(weather == "Snow"){
            setColorState("radial-gradient(circle, rgb(159, 207, 243) 0%, rgb(98, 151, 247) 100%)");
        }else{
            setColorState("radial-gradient(circle, rgb(41, 124, 188) 0%, rgb(8, 40, 101) 100%)");
        }
    },[data])

    return(
        <motion.div className="dim">
            <motion.section 
                className="left"
                initial={{x: "-100%"}}
                animate={{x: 0}}
                transition={{delay: 0.5, duration: 1}}
                exit={{x: "-100%"}}
            >
                <img src="/assets/images/01.jpg" alt="seoul"/>
            </motion.section>
            <motion.section 
                className="right"
                initial={{x: "100%"}}
                animate={{x: 0}}
                transition={{delay: 0.5, duration: 1}}
                exit={{x: "100%"}}
                >
                    <Suspense fallback={<div>Loading...</div>}>
                        <Content data={data[0].weatherData}/> 
                    </Suspense>             
            </motion.section>
        </motion.div>
    )
}